import { render } from "./PurchaseReturnReportPage.vue?vue&type=template&id=5ad14aee&scoped=true&ts=true"
import script from "./PurchaseReturnReportPage.vue?vue&type=script&lang=ts"
export * from "./PurchaseReturnReportPage.vue?vue&type=script&lang=ts"

import "./PurchaseReturnReportPage.vue?vue&type=style&index=0&id=5ad14aee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad14aee"]])

export default __exports__